module.exports = require('./helpers/bundle-url').getBundleURL('es2gC') + "logo.c51670a8.svg";